import { render, staticRenderFns } from "./ApsForm.vue?vue&type=template&id=134b3454"
import script from "./ApsForm.vue?vue&type=script&lang=js"
export * from "./ApsForm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports